/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: David Helmick
 * @ Modified time: 2025-10-23 14:20:56
 * @ Description: Component used to add files from the user's system
 */

import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
// Centralized lodash imports - much cleaner!
import {
  includes,
  head,
  map,
  isNil,
  startsWith,
} from '@/utils/lodash'
import {
  Grid,
  Button,
  Backdrop,
  CircularProgress,
  Typography,
  Tooltip,
  IconButton,
  Box,
} from '@mui/material'
import { useMutation } from '@apollo/client/react'
import axios from 'axios'
import { withUploadMember } from '@/utils/fileUpload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import withSession from '@/housefolios-components/Session/withSession'
import { GET_SIGNED_REQUEST } from '@/housefolios-components/PropertyContainer/queries'
import DeleteConfirmationDialog from '@/housefolios-components/Common/DeleteConfirmationDialog'
import { useDeleteConfirmation } from '@/housefolios-components/Common/DeleteConfirmationDialog/useDeleteConfirmation'

const MAXSIZE = 100000000 //bytes
const FILETYPES = ['application/pdf', 'image/*']

const FileUpload = (props) => {
  const [error, setError] = useState(null)
  const [progress, setProgress] = useState(null)
  const [fileToDelete, setFileToDelete] = useState(null)
  const [getSignedRequest] = useMutation(GET_SIGNED_REQUEST)

  const { open, loading, openDialog, closeDialog, handleDelete } =
    useDeleteConfirmation({
      onDelete: async () => {
        if (fileToDelete) {
          props.deleteFile(fileToDelete)
          setFileToDelete(null)
        }
      },
      successMessage: 'File deleted successfully',
      errorMessage: 'Failed to delete file',
    })

  const handleOpenDelete = (file) => {
    setFileToDelete(file)
    openDialog()
  }

  const handleCloseDelete = () => {
    setFileToDelete(null)
    closeDialog()
  }

  const validateFile = (file) => {
    if (file.size > MAXSIZE) {
      setError('file is too big')
      return false
    }

    // if (!includes(FILETYPES, file.type)) {
    //   setError('File Type not accepted')
    //   setProgress(null)
    //   return false
    // }
    return true
  }
  const getBase64ImageFromFile = async (file) => {
    if (!file) return null
    return new Promise((resolve, reject) => {
      var reader = new FileReader()
      reader.addEventListener(
        'load',
        function () {
          resolve(reader.result)
        },
        false,
      )

      reader.onerror = () => {
        return reject(this)
      }
      reader.readAsDataURL(file)
    })
  }
  const handleOnDrop = async (files, rejectedFiles) => {
    setError(null)
    setProgress(files.length)
    let fileData = await Promise.all(
      map(files, async (file) => {
        if (validateFile(file)) {
          if (props.notSave) {
            setProgress((prev) => prev - 1)
            const { profile = {} } = props.session.me
            const url = await getBase64ImageFromFile(file)
            return {
              filename: file.name,
              filesize: file.size,
              filetype: file.type,
              url: url,
              createdAt: new Date(),
              createdBy: `${profile.firstname} ${profile.lastname}`,
            }
          }
          const {
            data: { getSignedRequest: signed },
          } = await getSignedRequest({
            variables: {
              fileInput: withUploadMember(
                {
                  filename: file.name,
                  filetype: file.type,
                  collection: props.collection,
                  documentId: props.documentId,
                },
                props.session,
              ),
            },
          })
          const { signedRequest, url } = signed

          const options = {
            headers: {
              'Content-type': file.type,
            },
          }
          try {
            await axios.put(signedRequest, file, options)
            setProgress((prev) => prev - 1)
            const { profile = {} } = props.session.me
            return {
              filename: file.name,
              filesize: file.size,
              filetype: file.type,
              url: url,
              createdAt: new Date(),
              createdBy: `${profile.firstname} ${profile.lastname}`,
            }
          } catch (error) {
            return error
          }
        }
      }),
    )
    props.uploadFile(fileData)
    map(rejectedFiles, ({ file, errors  }) => {
      // if (this.validateFile(file)) {
      //   const fileReader = new FileReader()
      //   fileReader.addEventListener(
      //     'load',
      //     () => {
      //       const images = this.state.imgSrc
      //       images.push(fileReader.result)
      //       this.setState({ imgSrc: images  })
      //     },
      //     false,
      //   )
      //   fileReader.readAsDataURL(file)
      // }
      setError(head(errors).message)
    })
  }

  const { error: errorState = null, progress: progressState } = {
    error,
    progress,
  }
  const { files = null } = props
  const {
    button,
    notMulti = false,
    readOnly = false,
    writeOnly = false,
  } = props
  return (
    <Grid container direction="column">
      {!button &&
        map(files, (file) => {
          return (
            <Grid key={Math.random()}>
              <div>
                <Box style={{ backgroundImage: 'url(' + file.url_small + ')', }} sx={{ backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                  <img
                    alt={file.filename}
                    src={file.url}
                    style={{ width: 360 }}
                  />
                </Box>
              </div>
            </Grid>
          )
        })}
      <Grid>
        <Grid
          container
          style={
            props.buttonStyle
              ? props.buttonStyle
              : { marginTop: 25, marginBottom: 25 }
          }
          sx={{
            alignItems: 'center',
          }}
        >
          {!readOnly && (
            <Grid size={writeOnly ? 12 : 10}>
              <Dropzone
                onDrop={handleOnDrop}
                accept={
                  props.filetypes
                    ? Object.fromEntries(
                        props.filetypes.map((type) => [type, []]),
                      )
                    : undefined
                }
                maxSize={MAXSIZE}
                multiple={!notMulti}
                maxFiles={props.maxFiles ? props.maxFiles : null}
                disabled={props.shared || props.disabled}
                noClick
              >
                {({ getRootProps, getInputProps, open  }) => (
                  <section style={{ padding: 0 }}>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <Button
                        size="small"
                        variant="contained"
                        color={
                          props.buttonColor
                            ? props.buttonColor
                            : 'primary'
                        }
                        onClick={open}
                        disabled={props.shared || props.disabled}
                      >
                        {props.buttonIcon ? props.buttonIcon : ''}
                        {props.buttonText
                          ? props.buttonText
                          : 'Upload File'}
                      </Button>
                    </div>
                  </section>
                )}
              </Dropzone>
            </Grid>
          )}
          {!writeOnly &&
            map(files, (file, index) => (
              <Grid
                onClick={(event) => event.stopPropagation()}
                style={{ marginLeft: 10 }}
              >
                <Tooltip title={file.filename}>
                  {startsWith(file.url, 'data:') ? (
                    <a
                      onClick={() => {
                        var iframe =
                          "<iframe width='100%' height='100%' src='" +
                          file.url +
                          "'></iframe>"
                        var x = window.open()
                        x.document.open()
                        x.document.write(iframe)
                        x.document.close()
                      }}
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={['fas', 'paperclip']} />
                    </a>
                  ) : (
                    <a
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={['fas', 'paperclip']} />
                    </a>
                  )}
                </Tooltip>
                {!readOnly && props.deleteFile && (
                  <IconButton
                    onClick={() => handleOpenDelete(file)}
                    disabled={props.shared}
                    size="large"
                  >
                    <FontAwesomeIcon icon={['far', 'circle-xmark']} sx={{ fontSize: "1rem !important" }} />
                  </IconButton>
                )}
              </Grid>
            ))}
        </Grid>
        {error && <Box sx={{ color: '#f83245' }}>{error}</Box>}
      </Grid>
      <DeleteConfirmationDialog
        open={open}
        onClose={handleCloseDelete}
        onConfirm={handleDelete}
        title="Delete File?"
        confirmationText="Are you sure you want to delete this file? This action cannot be undone."
        successMessage="File deleted successfully"
        errorMessage="Failed to delete file"
        loading={loading}
        loadingMessage="Deleting File"
        showSharedWarning={false}
        sharedWarningText=""
        icon="trash-can"
        iconStyle="fas"
        cancelButtonText="Cancel"
        deleteButtonText="Delete"
        requireConfirmation={true}
        children={null}
      />
      <Backdrop
        open={progress > 0}
        style={{ color: '#fff', zIndex: 100000 }}
      >
        <Grid
          container
          direction="column"
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid>
            <CircularProgress
              variant="indeterminate"
              color="inherit"
            />
          </Grid>
          <Grid>
            <Typography
              sx={{
                color: 'inherit',
              }}
            >
              Uploading Files
            </Typography>
          </Grid>
        </Grid>
      </Backdrop>
    </Grid>
  )
}

export default withSession(FileUpload)
